import { StatsDisplay } from '@components/arsenal/StatsDisplay';
import { ArsenalBack } from '@components/arsenal/ArsenalBack';
import { capitalize } from '@helpers/dotNotation';
import { useTranslation } from 'react-i18next';
import * as Shared from '@shared/lib';

interface WeaponInfoProps {
  weapon: string;
  onBack?: () => void;
}

export function WeaponHeader({ weapon }: { weapon: string }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Weapon' });

  return (
    <>
      <div className="h-48 border-b border-secondary p-4 relative flex justify-center">
        <div className="absolute inset-0 grid-overlay" />
        <div className="absolute inset-0 bg-black/40" />
        <img className="max-w-[100%] max-h-[100%] my-auto blur-animation"
          src={`/img/weapons/${weapon}.avif`}
          alt={weapon}
        />
      </div>

      <div className="p-2 text-left">
        <p className="text-lg font-bold leading-tight text-shield">{capitalize(weapon)}</p>
        <p className="text-gray-300 text-xs mt-2 italic">{t(`${capitalize(weapon)}.lore`)}</p>
      </div>
    </>
  );
}

export function WeaponInfo({ weapon, onBack }: WeaponInfoProps) {
  const data = Shared.weaponsData.find((c) => c.key === weapon);
  if (!data) return null;

  return (
    <>
      {onBack && (
        <ArsenalBack bg="weapons.avif" onClick={onBack} />
      )}

      <WeaponHeader weapon={data.key} />
      <StatsDisplay value={data.key} type="weapon" />
    </>
  );
}